module.exports = __webpack_public_path__ + "img/coming-soon.7374332a.svg";